import { render, staticRenderFns } from "./WelcomeVideo.vue?vue&type=template&id=2a9b68e8&scoped=true&"
var script = {}
import style0 from "./WelcomeVideo.vue?vue&type=style&index=0&id=2a9b68e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9b68e8",
  null
  
)

export default component.exports